var exports = {
  "iE": "xfd349460--d8c1b4--wrapper" + " " + __webpack_require__(33767)["sectorWithSticky"],
  "wx": "xfd349460--d8c1b4--header",
  "yJ": "xfd349460--d8c1b4--links",
};

module.exports = exports;
